export interface UploadBillPayload {
  gstOutstandingAmount: number | null;
  challanId: string;
  challanAmount: number | null;
  file: File | null;
  challanType: string;
  processing_fees: number;
}
export interface UploadBillRequest {
  data: UploadBillPayload;
  redirect?: () => void;
}
export interface GetBillListResponse {
  noOfPending: number;
  noOfRejected: number;
  noOfApproved: number;
  noOfPaidWithReceipt: number;
  noOfPaidWithoutReceipt: number;
  challanDetailsSet: BillDetails[];
}

export interface BillDetails {
  id: number;
  gstOutstandingAmount: number;
  challanId: string;
  challanAmount: number;
  challanUrl: string;
  filename: string;
  isValid: boolean | null;
  rejectReason: string;
  invalidCount: number;
  updatedOn: string;
  paymentStatus: BillStatus;
  dmiS3Key?: string;
  createdAt?: string;
  jitfinS3Key: string;
  jitfinReceiptKey?: string | null;
  jitfinReceiptUrl?: string;
  dmiReceiptKey?: string | null;
  type: string;
  loanRequest: number;
}

export interface UploadBillResponse {
  success: boolean;
  message: string;
}
export enum BillStatus {
  Pending = "pending",
  Approved = "approved",
  "Pending Receipt" = "paid_without_receipt",
  "Receipt Uploaded" = "paid_with_receipt",
  Rejected = "rejected"
}
